import type { FC } from "react";
import { STATUS } from "../../theme/tokens";
import { LedgerLine } from "../UIToolkit/molecules/LedgerLine";
import { type LineContext, useCompositionLineContent } from "./useCompositionLineContent";
import type { CompositionLine } from "./wageComposition";

type Props = LineContext & { line: CompositionLine };

/**
 * One line of a segment's rate: the base it starts from, then each rule — named exactly as configured,
 * with the scope that made it match — and its $/h. The figure sits in the RATE column, bare of a unit, so
 * the lines read as the sum of the segment's rate directly above them. Amounts show only with wages
 * revealed; labels and links stay.
 */
export const CompositionLineView: FC<Props> = ({ line, ...context }) => {
	const { label, detail, rate } = useCompositionLineContent(line, context);
	return (
		<LedgerLine
			variant="component"
			label={label}
			detail={detail}
			rate={rate}
			dataTestId={`wage-breakdown-line-${context.rowId}-${context.index}`}
			figureColor={line.type !== "base" && line.type !== "training" && line.cents >= 0 ? STATUS.SUCCESS.main : undefined}
		/>
	);
};
